import React, { createContext, useContext, useState, useCallback } from 'react';

const PartnerModalContext = createContext();

export const PartnerModalProvider = ({ children }) => {
  const [isPartnerModalOpen, setIsPartnerModalOpen] = useState(false);
  const openPartnerModal = useCallback(() => setIsPartnerModalOpen(true), []);
  const closePartnerModal = useCallback(() => setIsPartnerModalOpen(false), []);

  return (
    <PartnerModalContext.Provider value={{ isPartnerModalOpen, openPartnerModal, closePartnerModal }}>
      {children}
    </PartnerModalContext.Provider>
  );
};

export const usePartnerModal = () => useContext(PartnerModalContext); 